import ServicesModel from "models/services/services";

const mainStore = {
  services: new ServicesModel()
};

export default mainStore;
